import { Link } from 'react-router-dom';
import { Button, Typography, Grid } from '@material-ui/core';

import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import green from '@material-ui/core/colors/green';

import { useStyles } from '../theme';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  red: {
    color: red[500]
  },
  orange: {
    color: orange[800]
  },
  yellow: {
    color: yellow[600]
  },
  green: {
    color: green[900]
  },
  critical: {
    backgroundColor: red[100]
  },
  high: {
    backgroundColor: orange[100]
  },
  medium: {
    backgroundColor: yellow[100]
  },
  low: {
    backgroundColor: green[100]
  },
  statsGrid: {
    textAlign: 'center'
  },
  filterButton: {
    textTransform: 'none'
  }
});

const bucketPriorities = [
  { title: 'critical', color: 'red' },
  { title: 'high', color: 'orange' },
  { title: 'medium', color: 'yellow' },
  { title: 'low', color: 'green' }
];

const capitalize = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const Priorities = ({allBucketCounts, gigCountsByRule}) => {
  const classes = useStyles(styles);

    return (
      <>
        <Grid
          container
          spacing={3}
          className={classes.statsGrid}
          justifyContent="space-evenly"
        >
          {bucketPriorities.map((priority) => (
            <Grid item xs={3} key={priority.title}>
              <Button
                component={Link}
                to={'/bucketsByPriority/' + priority.title}
                className={classes.filterButton}
              >
                <Typography variant="h5" className={classes[priority.color]}>
                  {allBucketCounts[priority.title]} {capitalize(priority.title)}
                </Typography>
              </Button>
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          spacing={1}
          className={classes.statsGrid}
          justifyContent="space-evenly"
          style={{ marginTop: -16 }}
        >
          {bucketPriorities.map((priority) => (
            <Grid item xs={3} key={priority.title} style={{ marginBottom: 16 }}>
              {gigCountsByRule[priority.title].map((ruleCount) => (
                <Typography variant="body1" key={ruleCount.rule}>
                  <Button
                    component={Link}
                    to={
                      '/bucketsByPriority/' +
                      priority.title +
                      '/' +
                      ruleCount.rule
                    }
                  >
                    <Typography variant="body1" style={{ color: 'grey' }}>
                      {ruleCount.rule}: {ruleCount.count}
                    </Typography>
                  </Button>
                </Typography>
              ))}
            </Grid>
          ))}
        </Grid>
      </>
    );
};
